import { getProduct, getProducts, getProductForm, ProductFilter } from '@ttstr/api';
import { ThunkActionCreator } from '.';

export const PRODUCTS_REQUESTED = 'PRODUCTS.PRODUCTS_REQUESTED';
export const PRODUCTS_RECEIVED = 'PRODUCTS.PRODUCTS_RECEIVED';
export const PRODUCTS_RECEIVE_FAILED = 'PRODUCTS.PRODUCTS_RECEIVE_FAILED';
export const PRODUCTS_RECEIVE_DONE = 'PRODUCTS.PRODUCTS_RECEIVE_DONE';

export const PRODUCT_REQUESTED = 'PRODUCTS.PRODUCT_REQUESTED';
export const PRODUCT_RECEIVED = 'PRODUCTS.PRODUCT_RECEIVED';
export const PRODUCT_RECEIVE_FAILED = 'PRODUCTS.PRODUCT_RECEIVE_FAILED';
export const PRODUCT_RECEIVE_DONE = 'PRODUCTS.PRODUCT_RECEIVE_DONE';

export const defaultProductsFilter: ProductFilter = { type: ['Product', 'Package', 'ValueCouponProduct'] };

export const receiveProducts: ThunkActionCreator = (
  filter: ProductFilter = defaultProductsFilter,
  options?: RequestInit
) => async (dispatch) => {
  dispatch({
    type: PRODUCTS_REQUESTED,
  });

  try {
    const products = await getProducts(filter, options);

    dispatch({
      type: PRODUCTS_RECEIVED,
      payload: {
        products,
      },
    });
  } catch (error) {
    dispatch({
      type: PRODUCTS_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
  } finally {
    dispatch({
      type: PRODUCTS_RECEIVE_DONE,
    });
  }
};

export const receiveProduct: ThunkActionCreator = (id: number) => async (dispatch) => {
  dispatch({
    type: PRODUCT_REQUESTED,
  });

  try {
    const product = await getProduct(id);

    dispatch({
      type: PRODUCT_RECEIVED,
      payload: {
        product,
      },
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
  } finally {
    dispatch({
      type: PRODUCT_RECEIVE_DONE,
    });
  }
};

export const PRODUCT_FORM_REQUESTED = 'PRODUCTS.PRODUCT_FORM_REQUESTED';
export const PRODUCT_FORM_RECEIVED = 'PRODUCTS.PRODUCT_FORM_RECEIVED';
export const PRODUCT_FORM_RECEIVE_FAILED = 'PRODUCTS.PRODUCT_FORM_RECEIVE_FAILED';
export const PRODUCT_FORM_RECEIVE_DONE = 'PRODUCTS.PRODUCT_FORM_RECEIVE_DONE';

export const receiveProductForm: ThunkActionCreator = (formId: number) => async (dispatch) => {
  dispatch({
    type: PRODUCT_FORM_REQUESTED,
    payload: {
      formId,
    },
  });

  try {
    const productForm = await getProductForm(formId);

    dispatch({
      type: PRODUCT_FORM_RECEIVED,
      payload: {
        productForm,
      },
    });
    return productForm;
  } catch (e) {
    dispatch({
      type: PRODUCT_FORM_RECEIVE_FAILED,
      payload: {
        formId,
      },
    });
    throw e;
  } finally {
    dispatch({
      type: PRODUCT_FORM_RECEIVE_DONE,
      payload: {
        formId,
      },
    });
  }
};
